import { useState } from "react";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Lock, Eye, EyeOff } from "lucide-react";
import { images } from "../data/mock";

const INVESTOR_PASSWORD = "TuiglesiaInvest2026*";

export const PasswordGate = ({ onSuccess }) => {
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [shaking, setShaking] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (password === INVESTOR_PASSWORD) {
      sessionStorage.setItem("investor_auth", "true");
      onSuccess();
    } else {
      setError("Clave incorrecta. Verifica e intenta nuevamente.");
      setShaking(true);
      setTimeout(() => setShaking(false), 500);
    }
  };

  return (
    <div className="min-h-screen bg-brand-950 flex items-center justify-center px-6 relative overflow-hidden">
      {/* Decorative */}
      <div className="absolute top-20 right-20 w-72 h-72 bg-brand-light/5 rounded-full blur-3xl" />
      <div className="absolute bottom-20 left-20 w-96 h-96 bg-brand-500/5 rounded-full blur-3xl" />
      <div className="absolute inset-0 opacity-[0.02]" style={{
        backgroundImage: 'radial-gradient(circle, #00CCFF 1px, transparent 1px)',
        backgroundSize: '48px 48px'
      }} />

      <div className={`relative z-10 w-full max-w-md ${shaking ? 'animate-shake' : ''}`}>
        <div className="text-center mb-10">
          <img
            src={images.logoWhite}
            alt="Tu Iglesia App"
            className="h-16 w-auto mx-auto mb-6 opacity-80"
          />
          <h1 className="brand-heading text-3xl font-bold text-white mb-2">
            Portal de Inversores
          </h1>
          <p className="text-brand-200/40 text-sm">
            Acceso restringido. Ingresa tu clave para continuar.
          </p>
        </div>

        <form onSubmit={handleSubmit} className="p-8 rounded-3xl bg-white/[0.04] backdrop-blur-sm border border-brand-light/10">
          <div className="space-y-2 mb-6">
            <Label htmlFor="password" className="text-white/60 text-sm font-semibold">
              Clave de acceso
            </Label>
            <div className="relative">
              <Lock className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-white/30" />
              <Input
                id="password"
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => { setPassword(e.target.value); setError(""); }}
                placeholder="Ingresa la clave"
                className="bg-white/5 border-brand-light/15 text-white placeholder:text-white/20 rounded-xl h-12 pl-11 pr-11 focus:border-brand-light/40 focus:ring-brand-light/20"
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-4 top-1/2 -translate-y-1/2 text-white/30 hover:text-white/60 transition-colors"
              >
                {showPassword ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
              </button>
            </div>
            {error && (
              <p className="text-red-400 text-xs mt-2">{error}</p>
            )}
          </div>

          <Button
            type="submit"
            className="w-full bg-brand-light hover:bg-brand-400 text-brand-950 py-5 rounded-2xl font-bold transition-all duration-300 hover:scale-[1.02]"
          >
            Acceder
          </Button>
        </form>

        <div className="text-center mt-6">
          <a href="/" className="text-brand-light/30 hover:text-brand-light/60 text-sm transition-colors">
            Volver al inicio
          </a>
        </div>
      </div>

      <style>{`
        @keyframes shake {
          0%, 100% { transform: translateX(0); }
          20% { transform: translateX(-8px); }
          40% { transform: translateX(8px); }
          60% { transform: translateX(-6px); }
          80% { transform: translateX(6px); }
        }
        .animate-shake { animation: shake 0.4s ease-in-out; }
      `}</style>
    </div>
  );
};
